import React from "react";
import "../styles/global.css";

const PrivacyPolicy = () => {
  return (
    <main className="privacy-container">
      <h2>Privacy Policy</h2>
      <p>Last updated: 19/03/2025</p>

      <h3>1. Introduction</h3>
      <p>
        Welcome to Southern Homemove. We are committed to protecting your privacy and ensuring your personal data is handled securely and in compliance with UK GDPR.
      </p>

      <h3>2. What Data We Collect</h3>
      <p>
        We may collect and process the following information:
      </p>
      <ul>
        <li>Property-related inquiries</li>
        <li>Website usage data (e.g., cookies and analytics)</li>
      </ul>

      <h3>3. How We Use Your Data</h3>
      <p>
        We use your data for the following purposes:
      </p>
      <ul>
        <li>To respond to your inquiries</li>
        <li>To provide our services</li>
        <li>To improve our website and customer experience</li>
        <li>To comply with legal obligations</li>
      </ul>

      <h3>4. How We Store & Protect Your Data</h3>
      <p>
        We store your personal data securely and only retain it for as long as necessary. We implement appropriate security measures to protect against unauthorized access, alteration, or disclosure.
      </p>

      <h3>5. Sharing Your Data</h3>
      <p>
        We do not sell or share your personal data with third parties, except when required by law or to provide our services (e.g., with estate agencies we work with).
      </p>

      <h3>6. Your Rights</h3>
      <p>You have the right to:</p>
      <ul>
        <li>Access the data we hold about you</li>
        <li>Request correction of incorrect information</li>
        <li>Request deletion of your personal data</li>
        <li>Withdraw consent for data processing</li>
      </ul>

      <h3>7. Cookies</h3>
      <p>
        We use cookies to enhance your experience. You can manage your cookie preferences in your browser settings.
      </p>

      <h3>8. Contact Us</h3>
      <p>
        If you have any questions about this Privacy Policy, please contact us at:
        <br />
        <strong>Email:</strong> <a href="mailto:info@southernhomemove.co.uk">info@southernhomemove.co.uk</a>
      </p>
    </main>
  );
};

export default PrivacyPolicy;
